import React, { useEffect } from 'react';
import { LiliRadioChip, LiliRadioChipProps } from '../../DesignSystem/LiliRadioChip/LiliRadioChip';
import { LiliRadio } from '../../DesignSystem/LiliRadioChip/LiliRadio';

export enum RadioItemStyle {
  REGULAR,
  CHIP,
}

interface LiliRadioGroupProps<T> {
  items: LiliRadioChipProps<T>[];
  onChange: (value: T) => void;
  groupId: string;
  defaultSelectedItemIndex?: number | null;
  isVertical?: boolean;
  radioItemStyle?: RadioItemStyle;
}

export const LiliRadioChipGroup = (props: LiliRadioGroupProps<any>) => {
  const { items, onChange, groupId, defaultSelectedItemIndex, isVertical, radioItemStyle } = props;

  const [selectedValue, setSelectedValue] = React.useState<any | null>(defaultSelectedItemIndex === null ? null : items?.[defaultSelectedItemIndex || 0]?.value || '');

  useEffect(() => {
    onChange(selectedValue);
  }, [selectedValue]);

  return (
    <div className={`flex ${isVertical ? 'flex-col items-start gap-[12px]' : 'items-center gap-[16px]'}`}>
      {items.map((radioButton) => {
        switch (radioItemStyle) {
          case RadioItemStyle.REGULAR:
            return (
              <LiliRadio
                key={radioButton.value}
                radioGroupId={groupId}
                onClick={(value: any) => setSelectedValue(value)}
                checked={radioButton.value === selectedValue}
                value={radioButton.value}
                label={radioButton.label}
              />
            );
          case RadioItemStyle.CHIP:
          default:
            return (
              <LiliRadioChip
                key={radioButton.value}
                radioGroupId={groupId}
                onClick={(value: any) => setSelectedValue(value)}
                checked={radioButton.value === selectedValue}
                value={radioButton.value}
                label={radioButton.label}
                icon={radioButton.icon}
                description={radioButton.description}
              />
            );
        }
      })}
    </div>
  );
};
